import * as React from 'react';
import { Suspense } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import BoxID001 from './ID001/ID001';
import BoxID002 from './ID002';
import BoxID003 from './ID003';
import { Model } from './ID003/Model2';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Stars } from '@react-three/drei';
import BoxID004 from './ID004';
const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F7F7F9',
    ...theme.typography.body2,
    /*  padding: theme.spacing(1),  */
    color: theme.palette.text.secondary,
    boxShadow: 'none',
    height: '100%',
    borderRadius: 20,
    position: 'relative'
}));
export default function Body() {
    return (
        <Box className="max-w-full m-auto justify-center items-center phone:p-2  text lg:p-10 lg:pt-4 lg:pb-5 ipad:p-3   ipad:pb-0  phone:mb-3">
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={{ xs: 2, md: 2.5 }} columns={{ xs: 2, sm: 12, md: 12 }}>
                    <Grid item xs={8} >
                        <Item sx={{
                            padding: 3, cursor: 'pointer', "&:hover": {
                                transition: "background 1s",
                                backgroundColor: "#B6CAE0",
                                color: "#FFFFFF"
                            }
                        }}>
                            <BoxID001 />
                        </Item>
                    </Grid>
                    <Grid item xs={4}>
                        <Item sx={{
                            padding: 3, cursor: 'pointer', "&:hover": {
                                transition: "background 1s",
                                backgroundColor: "#FFC300",
                                color: "#FFFFFF",
                                
                            },
                            position: 'relative'
                        }}>
                            <BoxID002 />
                        </Item>
                    </Grid>

                    <Grid item xs={7}>

                        <Item sx={{
                            padding: 3, cursor: 'pointer', "&:hover": {
                                transition: "background 1s",
                                backgroundColor: "#2E2E2E",
                                color: "#FFFFFF"
                            }, 
                            position: 'relative'
                        }}>
                            <BoxID003></BoxID003>
                        </Item>
                    </Grid>
                    <Grid item xs={5}>
                        <Item sx={{
                            padding: 3, cursor: 'pointer', "&:hover": {
                                transition: "background 1s",
                                backgroundColor: "#475853",
                                color: "#FFFFFF"
                            },
                            position: 'relative'
                        }} >
                            <BoxID004 />
                        </Item>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}
